import React from 'react';
import { MdOutlineEast, MdOutlineWest } from 'react-icons/md';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onNext: () => void;
  onPrevious: () => void;
}

const Pagination = (props: PaginationProps) => {
  const { totalPages, currentPage, onPageChange, onNext, onPrevious } = props;

  const activeClass = 'bg-heading-500 text-white hover:!bg-heading-500';

  const baseClass =
    'w-8 h-8 flex items-center justify-center font-medium text-base leading-[1.25rem] rounded-full cursor-pointer text-body-500 duration-200 hover:bg-primary-25 focus:ring-2 focus:ring-primary-50';

  const disabledClass = '!bg-transparent !text-body-100 !cursor-not-allowed';

  return (
    <div className='flex items-center justify-center gap-2'>
      <button
        onClick={onPrevious}
        disabled={currentPage === 1}
        className={`${baseClass} ${currentPage === 1 ? disabledClass : ''}`}
      >
        <MdOutlineWest size={20} />
      </button>
      {Array.from({ length: totalPages }).map((_, index) => (
        <button
          className={`${baseClass} ${currentPage === index + 1 ? activeClass : ''}`}
          key={index}
          onClick={() => onPageChange(index + 1)}
        >
          {index + 1}
        </button>
      ))}
      <button
        onClick={onNext}
        disabled={currentPage === totalPages}
        className={`${baseClass} ${currentPage === totalPages ? disabledClass : ''}`}
      >
        <MdOutlineEast size={20} />
      </button>
    </div>
  );
};

export default Pagination;
